"use client";

import React from "react";
import { animate, stagger } from "motion";
import { splitText } from "motion-plus";
import { useEffect, useRef } from "react";
import cover from "../assets/img/cover/2.webp";
import { Box } from "@mui/material";

// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import EventNoteIcon from "@mui/icons-material/EventNote";

const Cover = ({ startAnimation }) => {
  const containerRef1 = useRef(null);
  const containerRef2 = useRef(null);
  const containerRef3 = useRef(null);
  const containerRef4 = useRef(null);

  useEffect(() => {
    if (!startAnimation) return;

    document.fonts.ready.then(() => {
      // **1st Animation - "We invite you to celebrate our"**
      if (containerRef1.current) {
        const { words } = splitText(containerRef1.current);

        words.forEach((word) => {
          word.style.visibility = "visible";
          word.classList.add("h1-1");
        });

        animate(
          words,
          { opacity: [0, 1], y: [10, 0] },
          {
            type: "spring",
            duration: 2,
            bounce: 0,
            delay: stagger(0.05, { start: 0.0 }),
          }
        );
      }

      // **2nd Animation - "wedding"**
      if (containerRef2.current) {
        const { words } = splitText(containerRef2.current);

        words.forEach((word) => {
          word.style.visibility = "visible";
          word.classList.add("h1-2");
        });

        animate(
          words,
          { opacity: [0, 1], y: [10, 0] },
          {
            type: "spring",
            duration: 2,
            bounce: 0,
            delay: stagger(0.05, { start: 1.0 }),
          }
        );
      }

      if (containerRef3.current) {
        const { words } = splitText(containerRef3.current);

        words.forEach((word) => {
          word.style.visibility = "visible";
          word.classList.add("h1-3");
        });

        animate(
          words,
          { opacity: [0, 1], y: [10, 0] },
          {
            type: "spring",
            duration: 2,
            bounce: 0,
            delay: stagger(0.05, { start: 1.0 }),
          }
        );
      }

      if (containerRef4.current) {
        const { words } = splitText(containerRef4.current);

        words.forEach((word) => {
          word.style.visibility = "visible";
          word.classList.add("h1-4");
        });

        animate(
          words,
          { opacity: [0, 1], y: [10, 0] },
          {
            type: "spring",
            duration: 2,
            bounce: 0,
            delay: stagger(0.05, { start: 1.0 }),
          }
        );
      }
    });
  }, [startAnimation]);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "90vh",
        backgroundImage: `url(${cover})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "0px",
        }}
      >
        <div className="container-1" ref={containerRef1}>
          <h1 className="h1">We invite you to celebrate our</h1>
        </div>

        <div className="container-1" ref={containerRef2}>
          <h1 className="h1">WEDDING</h1>
        </div>

        <div className="container-1" ref={containerRef3}>
          <h1 className="h1">2025.09.23</h1>
        </div>

        <div className="container-1" ref={containerRef4}>
          <h1 className="h1">THINGS Aoyama Organic Garden. dth</h1>
        </div>

        <Stylesheet />
      </Box>
    </Box>
  );
};

function Stylesheet() {
  return (
    <style>{`
            .container-1 {
                justify-content: center;
                align-items: center;
                width: 100%;
                text-align: left;
            }

            .h1 {
                visibility: hidden;  /* 初期状態は非表示 */
                font-weight: bold;
            }

            .h1-1 {
                font-size: 1.1rem;  /* サイズ調整 */
            }

            .h1-2 {
                margin-top: 5px;
                font-size: 3rem;  /* サイズ調整 */
                letter-spacing: 0.1em;
            }

            .h1-3 {
                margin-top: 5px;
                font-size: 0.8rem;  /* サイズ調整 */
            }

            .h1-4 {
                margin-top: 5px;
                font-size: 0.8rem;  /* サイズ調整 */
            }

            .split-word {
                will-change: transform, opacity;
                color: white;
            }

        `}</style>
  );
}

export default Cover;
